import React from 'react';
import { Check } from 'lucide-react';
import { PALETTES } from '@/lib/landing-theme-constants';

interface PalettePickerProps {
  value: string;
  onChange: (paletteId: string) => void;
}

export const PalettePicker: React.FC<PalettePickerProps> = ({ value, onChange }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {PALETTES.map((palette) => {
        const isSelected = value === palette.id;
        return (
          <button
            key={palette.id}
            type="button"
            onClick={() => onChange(palette.id)}
            className={`relative group rounded-lg border-2 p-3 text-left transition-all hover:shadow-md ${
              isSelected
                ? 'border-primary ring-2 ring-primary/20 shadow-sm'
                : 'border-border hover:border-primary/40'
            }`}
          >
            {isSelected && (
              <div className="absolute top-1.5 right-1.5 h-5 w-5 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
                <Check className="h-3 w-3" />
              </div>
            )}
            {/* Color swatch row */}
            <div className="flex gap-1 mb-2">
              {palette.previewSwatches.map((color, i) => (
                <div
                  key={i}
                  className="h-6 flex-1 rounded-sm first:rounded-l-md last:rounded-r-md border border-black/5"
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
            <div className="text-xs font-semibold text-foreground truncate">{palette.name}</div>
            <div className="text-[10px] text-muted-foreground leading-tight mt-0.5 line-clamp-1">
              {palette.description}
            </div>
          </button>
        );
      })}
    </div>
  );
};
